/* MONDSTEIN by Metagon · mds-drop.js · section mds-drop ("Und dann"). Ported from the mock's media/drop/drop.js.
   The frames of the drop film are drawn on a canvas; the scroll position picks the frame: frame 0 when the stage enters at
   85 % of the screen, the last frame when the stage is centred; scrolling up lifts the duvet again (short lerp).
   Frames load only when the stage is within 800 px (IntersectionObserver). A stage that needs no more than 820 px
   (device pixel ratio counted up to 2) gets the 800 px frames. Reduced motion: last frame. .is-landed on the last two frames.
   Markup: [data-drop] with data-frames / data-frames-sm = URL patterns containing {n} (000, 001, ...), data-n = frame count. */
import { $$, boot, claim, reduce } from '@mds/core';

function init(root) {
  $$('[data-drop]', root).forEach((fig) => {
    if (!claim(fig, 'Drop')) return;
    const cv = fig.querySelector('canvas');
    if (!cv) return;
    const ctx = cv.getContext('2d');
    const N = +fig.getAttribute('data-n') || 1;
    const imgs = [];
    let cur = -1, show = 0, target = 0, raf = 0, on = false;
    const listen = (add) => {
      const m = add ? 'addEventListener' : 'removeEventListener';
      document[m]('scroll', onScroll, { capture: true, passive: true });
      window[m]('resize', onScroll);
    };
    function draw(i) {
      for (let k = i; k >= 0; k--) {
        const im = imgs[k];
        if (im && im.complete && im.naturalWidth) {
          ctx.drawImage(im, 0, 0, cv.width, cv.height); cur = i;
          fig.classList.add('is-on'); fig.classList.toggle('is-landed', i >= N - 2);
          return;
        }
      }
    }
    function progress() {
      const r = cv.getBoundingClientRect(), vh = window.innerHeight;
      const a = vh * 0.85, b = vh * 0.5 - r.height / 2;
      return Math.min(1, Math.max(0, (a - r.top) / (a - b)));
    }
    function tick() {
      show += (target - show) * 0.2;
      if (Math.abs(target - show) < 0.002) show = target;
      const i = Math.round(show * (N - 1));
      if (i !== cur) draw(i);
      raf = show !== target ? requestAnimationFrame(tick) : 0;
    }
    function onScroll() {
      if (!fig.isConnected) { listen(false); return; }   // section re-rendered in the theme editor
      target = reduce ? 1 : progress(); if (!raf) raf = requestAnimationFrame(tick);
    }
    function load() {
      // LIMIT: device pixel ratio counted up to 2; chosen once, at the first approach
      let pat = fig.getAttribute('data-frames');
      const sm = fig.getAttribute('data-frames-sm');
      if (sm && cv.getBoundingClientRect().width * Math.min(window.devicePixelRatio || 1, 2) <= 820) {
        pat = sm; cv.height = Math.round(cv.height * 800 / cv.width); cv.width = 800;
      }
      // reduced motion shows only the last frame, so only that one loads (review L4)
      for (let i = reduce ? N - 1 : 0; i < N; i++) {
        const im = new Image(); im.decoding = 'async';
        im.onload = () => { cur = -1; onScroll(); };
        im.src = pat.replace('{n}', String(i).padStart(3, '0'));
        imgs[i] = im;
      }
    }
    new IntersectionObserver((es) => {
      if (es[0].isIntersecting === on) return;
      on = es[0].isIntersecting;
      if (on && !imgs.length) load();
      listen(on);
      if (on) onScroll();
    }, { rootMargin: '800px 0px' }).observe(fig);
  });
}

boot(init);
